import PropTypes from "prop-types";
import React from "react";
import Avatar from "./Avatar";
import "./MateriaCard.css";
import Text from "./Text";
import LikeButton from "./LikeButton";
import Flexbox from "./Flexbox";

const MateriaCard = (props) => {
	const { mode, materia, checked, liked, onChange, className, icon } = props;
	const { nombre, clave, aula, docente } = materia;

	return (
		<article
			className={`MateriaCard MateriaCard__${mode} ${
				!docente || !aula ? "MateriaCard__lite" : ""
			} ${className}`}>
			<div className="MateriaCard-Info">
				{clave && (
					<Text className="MateriaCard-Info-Clave">
						{String(clave).padStart(4, "0")}
					</Text>
				)}
				{aula && mode === "default" && (
					<Text className="MateriaCard-Info-Aula">{aula}</Text>
				)}
			</div>
			<Text weight={700} type="paragraph" className="MateriaCard-NombreMateria">
				{nombre}
			</Text>
			{docente && mode === "default" && (
				<div className="MateriaCard-DocenteInfo">
					<Avatar src={docente.imagen} alt={docente.nombre} />
					<span className="MateriaCard-DocenteNombre">{docente.nombre}</span>
				</div>
			)}
			{mode === "checkbox" && (
				<div className="custom-control custom-checkbox">
					<input
						type="checkbox"
						className="custom-control-input"
						id={`check${clave}`}
						defaultChecked={checked}
						onChange={onChange}
					/>
					<label className="custom-control-label" htmlFor={`check${clave}`} />
				</div>
			)}
			{mode === "likeable" && <LikeButton liked={liked} size={30} />}
			{icon && (
				<Flexbox alignItems="center" justifyContent="flex-end">
					{icon}
				</Flexbox>
			)}
		</article>
	);
};

MateriaCard.propTypes = {
	materia: PropTypes.shape({
		nombre: PropTypes.string.isRequired,
		clave: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		aula: PropTypes.string,
		docente: PropTypes.shape({
			imagen: PropTypes.string,
			nombre: PropTypes.string
		})
	}).isRequired,
	mode: PropTypes.oneOf(["default", "checkbox", "likeable"]),
	checked: PropTypes.bool,
	liked: PropTypes.bool,
	onChange: PropTypes.func,
	className: PropTypes.string,
	icon: PropTypes.node
};

MateriaCard.defaultProps = {
	mode: "default",
	checked: false,
	liked: false,
	onChange: null,
	className: "",
	icon: null
};

export default MateriaCard;
